export var MeetingType;
(function (MeetingType) {
    MeetingType["CHAT"] = "chat";
    MeetingType["WEBRTC"] = "webrtc";
    MeetingType["SFU"] = "SFU";
})(MeetingType || (MeetingType = {}));
export var CameraFacingMode;
(function (CameraFacingMode) {
    CameraFacingMode["Front"] = "user";
    CameraFacingMode["Back"] = "environment";
})(CameraFacingMode || (CameraFacingMode = {}));
var MeetingStartRequest = /** @class */ (function () {
    function MeetingStartRequest(_roomId, _userId, _appId, _wssUrl) {
        this.videoCaptureWidth = 0;
        this.videoCaptureHeight = 0;
        this.defaultWhiteboardEditEnable = true;
        this.numberOfUsers = 10;
        this.isAdmin = false;
        this.userData = {};
        this.apiData = {};
        this.isMobileApp = false;
        this.shouldForceTurn = false;
        this.minBitrateConfig = 40000;
        this.maxBitRateConfig = 620000;
        this.logLevel = "TRACE";
        this.isRecordingUser = false;
        this.meetingType = MeetingType.SFU;
        this.defaultAudioBlocked = false;
        this.defaultVideoBlocked = false;
        this.defaultScreenShareBlocked = false;
        this.defaultCameraFacingMode = CameraFacingMode.Front;
        this.simulcastEncodings = [{ maxBitrate: 40000, scaleResolutionDownBy: 2.0 }, { maxBitrate: 620000, scaleResolutionDownBy: 1.0 },];
        this.urlToCheckInternetPresent = "https://en.wikipedia.org/w/api.php?format=json&action=query&prop=extracts&exintro&explaintext&redirects=1&titles=Stack%20Overflow";
        this.roomId = _roomId;
        this.userId = _userId;
        this.appId = _appId;
        if (_wssUrl.indexOf("connection=") < 0) {
            _wssUrl = _wssUrl + "/?connection=";
        }
        this.wssUrl = _wssUrl;
    }
    return MeetingStartRequest;
}());
export { MeetingStartRequest };
